var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":".5"},React.createElement("path",{"stroke":"#3E424E","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M2 70V55.264c0-8.22 6.718-14.925 14.954-14.925h7.308M70 70V55.264c0-8.213-6.718-14.925-14.954-14.925H49.21M36.403 35.148c9.172 0 16.607-7.42 16.607-16.574C53.01 9.42 45.575 2 36.403 2c-9.171 0-16.606 7.42-16.606 16.574 0 9.153 7.435 16.574 16.606 16.574zM27.509 58.403l6.639 5.634M46.104 49.128l-11.956 14.91"})));
}

User.defaultProps = {"width":"72","height":"72","fill":"none","viewBox":"0 0 72 72"};

module.exports = User;

User.default = User;
